<template>
  <div class="demo-split">
    <Row style="padding: 5px; background: #495060;">
      <Input search @on-search="onFilterClick" size="small" :disabled="playControl.playing" clearable v-model="registrationNum" placeholder="车牌号"
             style="width: 200px; margin-right: 3px;"></Input>
      <Input search @on-search="onFilterClick" size="small" :disabled="playControl.playing" clearable v-model="terminalNum" placeholder="终端主机号"
             style="width: 200px; margin-right: 3px;"></Input>
      <DatePicker :disabled="playControl.playing" size="small" type="datetimerange" :start-date="new Date()" placement="bottom-end"
                  placeholder="定位时间范围" style="width: 400px;margin-right: 3px;" @on-change="timeChange"
                  v-model="dateFilter"></DatePicker>
      <Button type="primary" size="small" :disabled="playControl.playing" style="margin-right: 20px;" @click="onFilterClick">查询</Button>
<!--      <Button type="primary" size="small" :disabled="playControl.playing" style="margin-right: 20px;" @click="onExportReport">导出</Button>-->
      <Button size="small" type="primary" style="margin-right: 3px;" @click="uploadExcel=true">导入生成轨迹</Button>
    </Row>
    <split-pane v-model="offset" mode="vertical" @on-move-end="onVehicleInfoSplitMoveEnd" ref="splitV">
      <div slot="top" class="demo-split-pane">
        <div style="height: 100%;">
          <div style="width: 100%; height: 100%;" id="qqmap"></div>
          <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="mapLoadding">
            <Spin size="large"></Spin>
            <h6 style="color:#2d8cf0;margin-top:10px;">正在加载轨迹数据...</h6>
          </div>
        </div>
        <div style="padding: 5px; padding-right:15px; padding-left:15px; background: #495060;height:130px;width:100%;position:absolute;z-index:200;bottom:0;text-align:center;">
          <Row>
            <div style="color: #e8e8e8;width: 100%;">
              <label style="margin-right: 10px;">定位时间:<label style="color: #348EED;">{{playControl.display.locateDatetime}}</label></label>
              <label style="margin-right: 10px;">状态:<label style="color: #348EED;">{{playControl.display.state}}</label></label>
              <label style="margin-right: 10px;">报警:<label style="color: #348EED;">{{playControl.display.alarmSign}}</label></label>
              <label style="margin-right: 10px;">速度:<label style="color: #348EED;">{{playControl.display.speed}}</label></label>
              <label style="margin-right: 10px;">累计里程:<label style="color: #348EED;">{{playControl.display.mileage}}</label></label>
              <label style="margin-right: 10px;">方向:<label style="color: #348EED;">{{playControl.display.direction}}</label></label>
              <label style="margin-right: 10px;">经度:<label style="color: #348EED;">{{playControl.display.longitude}}</label></label>
              <label style="margin-right: 10px;">纬度:<label style="color: #348EED;">{{playControl.display.latitude}}</label></label>
              <label style="margin-right: 10px;">接收时间:<label style="color: #348EED;">{{playControl.display.recvDatetime}}</label></label>
            </div>
          </Row>
          <Row>
            <div style="width: 100%;">
            <Slider style="width: 100%" :disabled="playControl.playing || content.length === 0" v-model="playControl.currentFrameIndex" :max="content.length" show-input @on-change="onSliderChange"></Slider>
            </div>
          </Row>
          <Row>
            <div style="width: 100%">
            <Button type="primary" :disabled="playControl.playing || content.length === 0" style="margin-right: 5px;"
                    @click="prevRunFrame" shape="circle" icon="md-skip-backward"></Button>
            <Button type="primary" :disabled="playControl.playing || content.length === 0" style="margin-right: 5px;"
                    @click="prevFrame" shape="circle" icon="md-rewind"></Button>
            <Button type="primary" :disabled="playControl.playing || content.length === 0" style="margin-right: 5px;"
                    @click="play" shape="circle" icon="md-play"></Button>
            <Button type="primary" :disabled="!playControl.playing || content.length === 0" style="margin-right: 5px;"
                    @click="pause" shape="circle" icon="md-pause"></Button>
            <Button type="primary" :disabled="playControl.playing || content.length === 0" style="margin-right: 5px;"
                    @click="stop" shape="circle" icon="md-square"></Button>
            <Button type="primary" :disabled="playControl.playing || content.length === 0" style="margin-right: 5px;"
                    @click="nextFrame" shape="circle" icon="md-fastforward"></Button>
            <Button type="primary" :disabled="playControl.playing || content.length === 0" style="margin-right: 5px;"
                    @click="nextRunFrame" shape="circle" icon="md-skip-forward"></Button>
            <Select :disabled="playControl.playing || content.length === 0"
                    style="margin-right: 5px; display: inline-block; width: 60px;" v-model="playControl.playInterval">
              <Option value="2000" key="2000">X1</Option>
              <Option value="1000" key="1000">X2</Option>
              <Option value="500" key="500">X4</Option>
              <Option value="250" key="250">X8</Option>
            </Select>
            </div>
          </Row>
        </div>
      </div>
      <div slot="bottom" class="demo-split-pane">
        <Row style="margin-top: 5px;">
          <div style="width: 100%;">
            <div style="position:relative;">
              <context-menu ref="contextMenuRef" :menuList="menuList" @callback="onContextMenuCallback"></context-menu>
              <Table border highlight-row size="small" height="600" :columns="columns" :data="currentPageContent" ref="table"
                     :height="vehicleInfoTableHeight"
                     @on-sort-change="sortChange" @on-row-dblclick="onRowClick" @contextmenu.prevent.native="onTableRightClick($event)"></Table>
              <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoadding">
                <Spin size="large"></Spin>
                <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
              </div>
            </div>
            <Page size="small" :total="content.length" :page-size="pageSize" :current="pageIndex" :show-total="true" show-elevator @on-change="setPage"
                  style="text-align:right;margin-top:3px;"></Page>
          </div>
        </Row>
      </div>
    </split-pane>
    <web-table-columns-modal :columnList.sync="columns" :tableName="$options.name" v-model="webTableColumnsModal"></web-table-columns-modal>

  <Modal
    v-model="uploadExcel"
    title="导入生成轨迹"
    @on-ok="ok"
    @on-cancel="cancel"
    cancel-text=""
    width="300">

    <Upload style="display: inline-block;max-height: 23.99px;margin-right: 3px;"  action="" :before-upload="onReadXLSX">
      <Button type="primary" size="small" :disabled="playControl.playing" style="margin-right: 20px;">选择文件</Button>
    </Upload>

    <Button v-if="EXCELSrc" type="primary" size="small" @click="downloadTemple(EXCELSrc)" style="margin: 10px;">下载导入模板</Button>

  </Modal>

  </div>
</template>

<script>
import Vue from 'vue'
import store from '../../store'
import SplitPane from '_c/split-pane'
import { GPS } from '@/libs/positonUtils'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
import { explainAlarmSign, explainState, explainDirection, reverseExplainDirection} from '@/libs/jt808util'
import * as XLSX from 'xlsx'

export default {
  name: 'locateplayback',
  components: {
    SplitPane
  },
  data () {
    return {

      webTableColumnsModal: false,
      menuList: [
        { title: '设置表格列', content: {} }
      ],

      uploadExcel: false,
      // 导入模板地址
      EXCELSrc: '/ERP/history/uploadHistoryExcel.xlsx',

      content: [],
      currentPageContent: [],
      pageSize: 30,
      vehicleInfoTableHeight: 200,

      playControl: {
        playing: false,
        playInterval: 2000,
        playIntervalTimer: null,
        currentFrameIndex: 0,
        currentFrame: null,
        display: {
          locateDatetime: '无',
          state: '无',
          alarmSign: '无',
          speed: '无',
          mileage: '无',
          direction: '无',
          longitude: '无',
          latitude: '无',
          recvDatetime: '无'
        }
      },

      mapData: {
        vehicleRunMarkerImage: null,
        vehicleStopMarkerImage: null,
        startMarker: null,
        endMarker: null,
        polyline: null,
        selectMarker: null,
        infoWin: null
      },

      // 地图
      qqMap: null,
      mapLoadding: false,
      mapDefaultCenter: null,
      // 行驶车辆
      vehicleMarkerAnchor: null,
      vehicleMarkerSize: null,
      vehicleMarkerOrigin: null,
      vehicleMarkerIcon: null,
      // 停止车辆图标
      vehicleStopMarkerAnchor: null,
      vehicleStopMarkerSize: null,
      vehicleStopMarkerOrigin: null,
      vehicleStopMarkerIcon: null,

      vehicleMarkers: [],

      offset: 0.5,

      dateFilter: [],
      startDate: null,
      endDate: null,

      tableHeight: 160,
      pageIndex: 1,
      sort: null,
      listLoadding: false,
      registrationNum: null,
      terminalNum: null,
      columns: [
        {
          title: '终端主机号',
          resizable: true,
          key: 'terminalNum',
          ellipsis: 'true',
          width: 110
        },
        {
          title: '定位时间',
          resizable: true,
          key: 'locateDatetimeLongValue',
          // sortable: 'custom',
          ellipsis: 'true',
          width: 160,
          render: function (h, params) {
            if (params.row.locateDatetimeLongValue) {
              let d = new Date(params.row.locateDatetimeLongValue)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '状态',
          resizable: true,
          key: 'state',
          ellipsis: 'true',
          width: 600,
          render: function (h, params) {
            if (params.row.state !== 0) {
              let s = explainState(params.row.state)
              let ds = []
              s.forEach(item => {
                if (item === 'ACC开') {
                  if (params.row.speed === 0) {
                    ds.push(h('label', { style: { color: 'orange' } }, item + ','))
                  } else {
                    ds.push(h('label', { style: { color: 'green' } }, item + ','))
                  }
                } else if (item === 'ACC关') {
                  ds.push(h('label', { style: { color: 'red' } }, item + ','))
                } else if (item === '定位') {
                  ds.push(h('label', { style: { color: 'green' } }, item + ','))
                } else if (item === '未定位') {
                  ds.push(h('label', { style: { color: 'red' } }, item + ','))
                } else {
                  ds.push(h('label', item + ','))
                }
              })
              return h('div', ds)
            } else {
              return h('div', '无')
            }
          }
        },
        {
          title: '报警',
          resizable: true,
          key: 'alarmSign',
          ellipsis: 'true',
          width: 200,
          render: function (h, params) {
            if (params.row.alarmSign !== 0) {
              return h('div', explainAlarmSign(params.row.alarmSign))
            } else {
              return h('div', '无')
            }
          }
        },
        {
          title: '速度(km/h)',
          resizable: true,
          key: 'speed',
          ellipsis: 'true',
          width: 110,
          render: function (h, params) {
            if (params.row.speed !== 0) {
              return h('div', params.row.speed / 10)
            } else {
              return h('div', params.row.speed)
            }
          }
        },
        {
          title: '累计里程(km)',
          resizable: true,
          key: 'mileage',
          ellipsis: 'true',
          width: 140,
          render: function (h, params) {
            if (params.row.mileage !== 0) {
              return h('div', params.row.mileage / 10)
            } else {
              return h('div', params.row.mileage)
            }
          }
        },
        {
          title: '方向',
          resizable: true,
          key: 'direction',
          ellipsis: 'true',
          width: 60,
          render: function (h, params) {
            return h('label', explainDirection(params.row.direction))
          }
        },
        {
          title: '经度',
          resizable: true,
          key: 'longitude',
          ellipsis: 'true',
          width: 110
        },
        {
          title: '纬度',
          resizable: true,
          key: 'latitude',
          ellipsis: 'true',
          width: 110
        },
        {
          title: '接收时间',
          resizable: true,
          key: 'recvDatetimeLongValue',
          // sortable: 'custom',
          ellipsis: 'true',
          width: 160,
          render: function (h, params) {
            if (params.row.recvDatetimeLongValue) {
              let d = new Date(params.row.recvDatetimeLongValue)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        }
      ]// cloumn
    }// return
  }, // data
  methods: {
    /**
       * 表格右键回调
       */
    onTableRightClick (e) {
      this.$refs.contextMenuRef.showMenu(e, this.$el, 0, -20)
    },
    /**
       * 右键菜单点击回调
       */
    onContextMenuCallback (item) {
      if (item.title === '设置表格列') {
        this.webTableColumnsModal = true
      }
    },
    onRowClick (data, index) {
      if (!this.pageIndex) {
        this.pageIndex = 1
      }
      index = (this.pageIndex - 1) * 30 + index
      console.log('onRowClick:' + index)
      this.playControl.currentFrameIndex = index
      this.playControl.currentFrame = this.content[this.playControl.currentFrameIndex]
      let pos = GPS.gcj_encrypt(data.latitude, data.longitude)
      let p = new qq.maps.LatLng(pos.lat, pos.lon)
      this.mapData.selectMarker.setPosition(p)
      this.mapData.selectMarker.setMap(this.qqMap)
      this.mapData.selectMarker.setRotation(data.direction)
      if ((data.state & 0x01) === 0x01) {
        this.mapData.selectMarker.setIcon(this.mapData.vehicleRunMarkerImage)
      } else {
        this.mapData.selectMarker.setIcon(this.mapData.vehicleStopMarkerImage)
      }
      this.qqMap.setCenter(p)
      this.renderDisplay()
    },
    clearDraw () {
      if (this.mapData.startMarker) {
        this.mapData.startMarker.setMap(null)
        this.mapData.startMarker = null
      }
      if (this.mapData.endtMarker) {
        this.mapData.endtMarker.setMap(null)
        this.mapData.endtMarker = null
      }
      if (this.mapData.polyline) {
        this.mapData.polyline.setMap(null)
        this.mapData.polyline = null
      }
      if (this.mapData.selectMarker) {
        this.mapData.selectMarker.setMap(null)
        this.mapData.selectMarker = null
      }
    },
    drawTrack () {
      let startMarkerImage = new qq.maps.MarkerImage('/start.png', null, null, null, new qq.maps.Size(30, 40))
      let endMarkerImage = new qq.maps.MarkerImage('/end.png', null, null, null, new qq.maps.Size(30, 40))
      // if(!this.mapData.vehicleRunMarkerImage) {
      this.mapData.vehicleRunMarkerImage = new qq.maps.MarkerImage('/vehiclerun.png', new qq.maps.Size(24, 43), new qq.maps.Point(0, 0), new qq.maps.Point(12, 21))
      // }
      // if(!this.mapData.vehicleStopMarkerImage) {
      this.mapData.vehicleStopMarkerImage = new qq.maps.MarkerImage('/vehiclestop.png', new qq.maps.Size(24, 43), new qq.maps.Point(0, 0), new qq.maps.Point(12, 21))
      // }

      this.mapData.startMarker = new qq.maps.Marker({ icon: startMarkerImage })
      this.mapData.endtMarker = new qq.maps.Marker({ icon: endMarkerImage })
      this.mapData.selectMarker = new qq.maps.Marker({ icon: this.mapData.vehicleRunMarkerImage })

      let s = null
      let w = null
      let n = null
      let e = null
      let polylines = []
      let length = this.content.length
      let p = null

      for (var i = 0; i < length; i++) {
        if (i === 0) {
          let startPos = GPS.gcj_encrypt(this.content[i].latitude, this.content[i].longitude)
          this.mapData.startMarker.setPosition(new qq.maps.LatLng(startPos.lat, startPos.lon))
          this.mapData.startMarker.setMap(this.qqMap)

          let selectPos = GPS.gcj_encrypt(this.content[i].latitude, this.content[i].longitude)
          let p = new qq.maps.LatLng(selectPos.lat, selectPos.lon)
          this.mapData.selectMarker.setPosition(p)
          this.mapData.selectMarker.setMap(this.qqMap)
          this.mapData.selectMarker.setRotation(this.content[i].direction)
          if ((this.content[i].state & 0x01) === 0x01) {
            this.mapData.selectMarker.setIcon(this.mapData.vehicleRunMarkerImage)
          } else {
            this.mapData.selectMarker.setIcon(this.mapData.vehicleStopMarkerImage)
          }
        }

        if (i === length - 1) {
          let endPos = GPS.gcj_encrypt(this.content[i].latitude, this.content[i].longitude)
          this.mapData.endtMarker.setPosition(new qq.maps.LatLng(endPos.lat, endPos.lon))
          this.mapData.endtMarker.setMap(this.qqMap)
        }

        if (n === null) {
          n = this.content[i].latitude
        }
        if (s === null) {
          s = this.content[i].latitude
        }
        if (w === null) {
          w = this.content[i].longitude
        }
        if (e === null) {
          e = this.content[i].longitude
        }

        if (this.content[i].latitude < n) {
          n = this.content[i].latitude
        }
        if (this.content[i].latitude > s) {
          s = this.content[i].latitude
        }
        if (this.content[i].longitude < w) {
          w = this.content[i].longitude
        }
        if (this.content[i].longitude > e) {
          e = this.content[i].longitude
        }
        if (i < length - 1) {
          // let pos = {lat:this.content[i].latitude, lon:this.content[i].longitude}
          // console.log(this.content[i].latitude)
          // console.log(this.content[i].longitude)
          let pos = GPS.gcj_encrypt(this.content[i].latitude, this.content[i].longitude)
          // console.log(pos.lat)
          // console.log(pos.lon)
          polylines.push(new qq.maps.LatLng(pos.lat, pos.lon))
          // p = new qq.maps.Polyline({path: [new qq.maps.LatLng(this.content[i].latitude, this.content[i].longitude), new qq.maps.LatLng(this.content[i + 1].latitude, this.content[i + 1].longitude)]})
          // p.setMap(this.qqMap)
          // polylines.push(p)
        }
      }
      this.mapData.polyline = new qq.maps.Polyline({ path: polylines })
      this.mapData.polyline.setMap(this.qqMap)
      // console.log(polylines)
      console.log('s:' + s + ',w:' + w + ',n:' + n + ',e:' + e)
      this.qqMap.fitBounds(new qq.maps.LatLngBounds(new qq.maps.LatLng(s, w), new qq.maps.LatLng(n, e)))
    },
    initPlayControl () {
      this.playControl.currentFrameIndex = 0
      this.playControl.currentFrame = this.content[0]
      this.playControl.playInterval = 2000
    },
    renderDisplay () {
      let d = new Date(this.playControl.currentFrame.locateDatetimeLongValue)
      this.playControl.display.locateDatetime = d.Format('yyyy年MM月dd日 hh:mm:ss')
      this.playControl.display.state = explainState(this.playControl.currentFrame.state)
      this.playControl.display.alarmSign = explainAlarmSign(this.playControl.currentFrame.alarmSign)
      this.playControl.display.speed = this.playControl.currentFrame.speed / 10
      this.playControl.display.mileage = this.playControl.currentFrame.mileage / 10
      this.playControl.display.direction = explainDirection(this.playControl.currentFrame.direction)
      this.playControl.display.longitude = this.playControl.currentFrame.longitude
      this.playControl.display.latitude = this.playControl.currentFrame.latitude
      d = new Date(this.playControl.currentFrame.recvDatetimeLongValue)
      this.playControl.display.recvDatetime = d.Format('yyyy年MM月dd日 hh:mm:ss')
      console.log(this.playControl.display)
    },
    onSliderChange (val) {
      console.log('onSliderChange')
      this.playControl.currentFrameIndex = val
      this.playControl.currentFrame = this.content[this.playControl.currentFrameIndex]
      this.onRowClick(this.playControl.currentFrame, this.playControl.currentFrameIndex)
    },
    play () {
      if (this.playControl.playIntervalTimer) {
        clearInterval(this.playControl.playIntervalTimer)
        this.playControl.playIntervalTimer = null
      }
      this.playControl.playIntervalTimer = setInterval(this.onTimer, this.playControl.playInterval)
      this.playControl.playing = true
      this.$Message.success('开始播放')
    },
    pause () {
      if (this.playControl.playIntervalTimer) {
        clearInterval(this.playControl.playIntervalTimer)
        this.playControl.playIntervalTimer = null
      }
      this.playControl.playing = false
    },
    stop () {
      this.$Modal.confirm({
        title: '确定重置播放',
        content: '<p>将放弃当前播放进度</p>',
        onOk: () => {
          this.playControl.currentFrameIndex = 0
          this.playControl.currentFrame = this.content[this.playControl.currentFrameIndex]
          this.onRowClick(this.playControl.currentFrame, this.playControl.currentFrameIndex)
        },
        onCancel: () => {
        }
      })
    },
    nextFrame () {
      if (this.playControl.currentFrameIndex === this.content.length - 1) {
        this.$Message.error('已无下一条记录')
        return
      }
      this.playControl.currentFrameIndex = this.playControl.currentFrameIndex + 1
      this.playControl.currentFrame = this.content[this.playControl.currentFrameIndex]
      this.onRowClick(this.playControl.currentFrame, this.playControl.currentFrameIndex)
    },
    nextRunFrame () {
      let length = this.content.length
      for (var i = this.playControl.currentFrameIndex; i < length; i++) {
        if (this.content[i].speed > 0) {
          this.playControl.currentFrameIndex = i
          this.playControl.currentFrame = this.content[this.playControl.currentFrameIndex]
          this.onRowClick(this.playControl.currentFrame, this.playControl.currentFrameIndex)
          break
        }
      }
    },
    prevFrame () {
      if (this.playControl.currentFrameIndex === 0) {
        this.$Message.error('已无上一条记录')
        return
      }
      this.playControl.currentFrameIndex = this.playControl.currentFrameIndex - 1
      this.playControl.currentFrame = this.content[this.playControl.currentFrameIndex]
      this.onRowClick(this.playControl.currentFrame, this.playControl.currentFrameIndex)
    },
    prevRunFrame () {
      let length = this.content.length
      for (var i = this.playControl.currentFrameIndex; i >= 0; i--) {
        if (this.content[i].speed > 0) {
          this.playControl.currentFrameIndex = i
          this.playControl.currentFrame = this.content[this.playControl.currentFrameIndex]
          this.onRowClick(this.playControl.currentFrame, this.playControl.currentFrameIndex)
          break
        }
      }
    },
    onVehicleInfoSplitMoveEnd () {
      this.vehicleInfoTableHeight = this.$refs.splitV.$slots.bottom[0].elm.clientHeight - 130
    },
    downloadTemple (e) {
      console.log(e)
      window.location.href = e
    },
    onSuccess () {
      this.setPage(1)
    },
    onModifySuccess () {
      this.refreshPage(this.pageFilter)
    },
    onExportReport(){
      let url = '/api/history/locatehistory/exportexcel/' + this.terminalNum + '/' + this.startDate + '/' + this.endDate
      window.location.href = url
    },
    // 每次获取传入的时间都是格式化时间，但绑定的time其实是中国标准时间吗
    timeChange(time1) {
      if (time1[1].slice(-8) === '00:00:00') {
        time1[1] = time1[1].slice(0, -8) + '23:59:59'
        // 由于this.time是标准日期，因此必须使用这样的语句
        this.dateFilter = time1
      }
    },
    onReadXLSX(file, any){
      //清除轨迹线
      this.clearDraw()
      // 读入excel
      // const readXLSX = (file: any) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.readAsBinaryString(file)
          reader.onload = (evt, date) => {
            const data = evt.target.result
            const wb = XLSX.read(data, { type: 'binary' })
            const jsonData = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]], {
              // header: ['ID' ,'车牌', '主机号', '定位时间', '接收时间', '经度', '纬度', '方向', '速度', '位置', '里程(KM)', '详细状态', '当日里程(KM)']
              header: ['oid' ,'registrationNum', 'terminalNum', 'locateDatetime', 'recvDatetime', 'longitude', 'latitude', 'direction', 'speed', '位置', '里程(KM)', 'state', '当日里程(KM)']
            })
            jsonData.splice(0, 1) //删除表头
            resolve(jsonData)
      // console.log(jsonData)

            this.registrationNum = jsonData[0].registrationNum
            this.terminalNum = jsonData[0].terminalNum
            this.dateFilter = [new Date(jsonData[0].locateDatetime), new Date(jsonData[jsonData.length-1].locateDatetime)]
            // console.log(this.dateFilter)
            for (let i = 0; i < jsonData.length; i++) {
              jsonData[i].longitude = Number(jsonData[i].longitude)
              jsonData[i].latitude = Number(jsonData[i].latitude)
              jsonData[i].locateDatetime = new Date(jsonData[i].locateDatetime)
              jsonData[i].recvDatetime = new Date(jsonData[i].recvDatetime)
              //逆转换方向
              jsonData[i].direction = reverseExplainDirection(jsonData[i].direction)
            }
      // console.log(jsonData)
            this.content = jsonData
            //画轨迹线
            this.drawTrack()
            this.initPlayControl()
          }
          this.uploadExcel = false
        })
      // }
    },
    onFilterClick () {
      if (this.dateFilter.length==0) {
        this.startDate = null
        this.endDate = null
        this.loadData()
        return
      }
      if (this.dateFilter[0] === '' || this.dateFilter[1] === '') {
        this.startDate = null
        this.endDate = null
        this.loadData()
        return
      }
      let startDate = this.dateFilter[0]
      let endDate = this.dateFilter[1]
      this.startDate = new Date(startDate).Format('yyyy-MM-dd hh:mm:ss')
      this.endDate = new Date(endDate).Format('yyyy-MM-dd hh:mm:ss')
      this.loadData()
    },
    sortChange ({ column, key, order }) {
      this.sort = {
        name: key,
        asc: order === 'asc'
      }
      this.refreshPage()
    },
    loadData () {
      if (!this.terminalNum) {
        this.$Message.error('缺少终端主机号')
        return
      }
      if (!this.startDate || !this.endDate) {
        this.$Message.error('缺少查询定位时间范围')
        return
      }
      this.listLoadding = true
      this.clearDraw()
      store.dispatch('LocateHistoryServ_GetByLocationDatetime', {
        params: { terminalNum: this.terminalNum, startDatetime: this.startDate, endDatetime: this.endDate },
        urlparams: null
      }).then(() => {
        this.content = store.getters.get_LocateHistory_GetByLocationDatetimeResult
        this.setPage(1)
        this.drawTrack()
        this.initPlayControl()
        this.listLoadding = false
      }).catch(err => {
        this.content = []
        this.listLoadding = false
        this.$Message.error(err)
      })
    },
    setPage (index) {
      console.log('setPage' + index)
      let pageIndex = 0
      this.pageIndex = index
      if (this.pageIndex < 0) {
        this.pageIndex = 0
        pageIndex = 0
      } else {
        pageIndex = this.pageIndex - 1
      }
      let length = this.content.length
      let start = pageIndex * this.pageSize
      let end = (pageIndex + 1) * this.pageSize - 1
      if (end > length - 1) {
        end = length - 1
      }
      this.currentPageContent = this.content.slice(start, end)
    },
    // 刷新当前页
    refreshPage () {
      this.loadData()
    },
    mapInit () {
      this.mapDefaultCenter = new qq.maps.LatLng(39.916527, 116.397128)

      // this.vehicleMarkerAnchor = new qq.maps.Point(this.config.vehiclepngWidth / 2, this.config.vehiclepngHeight / 2)
      // this.vehicleMarkerSize = new qq.maps.Size(this.config.vehiclepngWidth, this.config.vehiclepngHeight)
      // this.vehicleMarkerOrigin = new qq.maps.Point(0, 0)
      // this.vehicleMarkerIcon = new qq.maps.MarkerImage(this.config.vehiclerunpng, this.vehicleMarkerSize, this.vehicleMarkerOrigin, this.vehicleMarkerAnchor)
      //
      // this.vehicleStopMarkerAnchor = new qq.maps.Point(this.config.vehiclepngWidth / 2, this.config.vehiclepngHeight / 2)
      // this.vehicleStopMarkerSize = new qq.maps.Size(this.config.vehiclepngWidth, this.config.vehiclepngHeight)
      // this.vehicleStopMarkerOrigin = new qq.maps.Point(0, 0)
      // this.vehicleStopMarkerIcon = new qq.maps.MarkerImage(this.config.vehiclestoppng, this.vehicleMarkerSize, this.vehicleMarkerOrigin, this.vehicleMarkerAnchor)

      this.qqMap = new qq.maps.Map(document.getElementById('qqmap'), {
        // 地图的中心地理坐标。
        center: this.mapDefaultCenter
      })
    },
    onTimer () {
      if (this.playControl.currentFrameIndex === this.content.length - 1) {
        if (this.playControl.playIntervalTimer) {
          clearInterval(this.playControl.playIntervalTimer)
          this.playControl.playIntervalTimer = null
        }
        this.$Message.success('播放完毕')
        return
      }
      this.playControl.currentFrameIndex = this.playControl.currentFrameIndex + 1
      this.playControl.currentFrame = this.content[this.playControl.currentFrameIndex]
      this.onRowClick(this.playControl.currentFrame, this.playControl.currentFrameIndex)
    }
  },
  computed: {
    // totalElements() {
    //   if (store.getters.get_LocateHistory_GetPageResult) {
    //     return store.getters.get_LocateHistory_GetPageResult.totalElements;
    //   } else {
    //     return 0;
    //   }
    //
    // },
    // content() {
    //   if (store.getters.get_LocateHistory_GetPageResult) {
    //     return store.getters.get_LocateHistory_GetPageResult.content;
    //   } else {
    //     return [];
    //   }
    //
    // },
    // pageSize() {
    //   if (store.getters.get_LocateHistory_GetPageResult) {
    //     return store.getters.get_LocateHistory_GetPageResult.size;
    //   } else {
    //     return 0;
    //   }
    //
    // }
  },
  mounted () {
    this.$nextTick(() => {
      this.mapInit()
      this.onVehicleInfoSplitMoveEnd()
      // this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140;
      // window.onresize = () => {
      //   this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140;
      // }
      // this.setPage(1);
    })
  },
  destroyed () {
    if (this.playControl.playIntervalTimer) {
      clearInterval(this.playControl.playIntervalTimer)
      this.playControl.playIntervalTimer = null
    }
  }
}
</script>

<style scoped>
  .demo-split {
    height: 100%;
    width: 100%;
    border: 1px solid #dcdee2;
  }

  .demo-split-pane {
    width: 100%;
    height: 100%;
  }
</style>
